<template>
  <div class="page">
    <div class="row">
      <div class="sm-12">
        <div class="box-page">
          <div class="row">
            <div class="sm-12">
              <div class="title">
                <i class="mdi mdi-book-open-page-variant-outline"></i>
                <h2>Livro Digital</h2>
              </div>
            </div>
          </div>
          <div class="row" v-if="loading">
            <div class="sm-12">
              <p class="text-center">
                <i class="mdi mdi-loading mdi-spin mdi-48px"></i>
              </p>
            </div>
          </div>
          <div class="row" v-if="livros && livros.length == 0">
            <div class="sm-12">
              <p class="text-center">Nenhum livro encontrado.</p>
            </div>
          </div>
          <div v-else>
            <form action>
              <div class="row">
                <div class="sm-12 md-4">
                  <select v-model="ano">
                    <option value="">Ano</option>
                    <option :value="ano" v-for="ano in anos" :key="ano">
                      {{ ano }}
                    </option>
                  </select>
                </div>
                <div class="sm-12 md-4">
                  <select v-model="mes">
                    <option value="">Mês</option>
                    <option :value="mes" v-for="mes in meses" :key="mes">
                      {{ `${mes}`.padStart(2, "0") }}
                    </option>
                  </select>
                </div>
                <div class="sm-12 md-4">
                  <!--
                            <button class="button primary">OK</button>
                        -->
                </div>
              </div>
            </form>

            <div class="row" v-if="Livros.length != 0">
              <div class="sm-12">
                <div class="reponsive-table">
                  <table>
                    <thead>
                      <tr>
                        <th align="left">Ano</th>
                        <th align="left">Mês</th>
                        <th width="300"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <Livro
                        :livro="livro"
                        v-for="livro in Livros"
                        :key="livro.id"></Livro>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <Aprovacoes
              :ano="ano"
              :mes="mes"
              :codigo_condominio="codigo_condominio"
              v-if="ano && mes && show_aprovacao"></Aprovacoes>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//import api from '/plugins/api';
import Livro from "./livro-digital/livro.vue";
import Aprovacoes from "./livro-digital/aprovacoes/Aprovacoes.vue";

import {
  loadLivros,
  Livro as TipoLivro,
  StatusAprovacao,
} from "../../store/livro-digital/livros-repository";
export default {
  components: {
    Livro,
    Aprovacoes,
  },
  data() {
    return {
      loading: false,
      errors: [],
      livros: null,
      ano: "",
      mes: "",
    };
  },
  computed: {
    condominio() {
      return this.$store.getters.condominio;
    },
    /**
     * @return { number|null }
     */
    codigo_condominio() {
      if (!this.condominio) {
        return null;
      }
      return this.condominio.codigo;
    },
    controle_acesso() {
      return this.$store.getters.controleAcesso;
    },
    /**
     * @returns { boolean }
     */
    show_aprovacao() {
      return (
        (this.controle_acesso.livroDigital?.aprovacao || false) &&
        this.livro?.statusAprovacao != StatusAprovacao.NAO_APLICADO
      );
    },
    /**
     * @return { number[] }
     */
    anos() {
      if (!this.livros) {
        return [];
      }
      let anos = this.livros.map(({ ano }) => ano);
      anos = [...new Set(anos)];
      anos.sort((a, b) => (a > b ? -1 : 1));
      return anos;
    },
    /**
     * @returns { number[] }
     */
    meses() {
      if (this.anos.length == 0) {
        return [];
      }
      if (this.ano == "") {
        return [];
      }
      let meses = this.livros
        .filter(({ ano }) => ano == this.ano)
        .map(({ mes }) => mes);
      meses = [...new Set(meses)];
      meses.sort((a, b) => (a < b ? -1 : 1));
      return meses;
    },
    /**
     * @returns { TipoLivro|null }
     */
    livro() {
      if (this.Livros.length === 0) {
        return null;
      }
      let [livro] = this.Livros;

      return livro;
    },
    /**
     * @return { TipoLivro[] }
     */
    Livros() {
      if (!this.livros) {
        return [];
      }
      return this.livros.filter(
        ({ ano, mes }) => ano == this.ano && mes == this.mes
      );
    },
  },
  methods: {
    async loadLivros() {
      try {
        this.loading = true;
        this.errors = [];
        this.livros = null;

        this.livros = await loadLivros(this.codigo_condominio);
        if (this.anos.length > 0) {
          let [ano] = this.anos
          this.ano = ano
        }
        if (this.meses.length > 0) {
          let [mes] = this.meses.reverse()
          this.mes = mes
        }

        //let { data: livros } = await api.get(`/condominios/${this.codigo_condominio}/livro-digital`);
        //this.livros = livros;
      } catch (err) {
        console.error(err);
      }
      this.loading = false;
    },
  },
  watch: {
    codigo_condominio: {
      immediate: true,
      handler() {
        this.loadLivros();
      },
    },
    ano() {
      if (this.meses.length > 0) {
        let [mes] = this.meses
        this.mes = mes
      } else {
        this.mes = ''
      }
    },
  },
};
</script>
